import { Button } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TwoFactorSettings from '../TwoFactor/TwoFactorSettings';


const Security = () => {
    const navigate = useNavigate();
    console.log(navigate);
    return (
        <div className="container border-1x security_container margin-t-3x margin-b-2x padding-0 ">
            <h1 className="font_25x padding-tb-1x padding-lr-2x border-b-1x">Security</h1>
            <div className="padding-2x border-b-1x">
                <h4>Login Password</h4>
                <h6 className="font_17x">To keep your account secure, withdrawls are not permitted for 24 hours after changing your password.</h6>
                <Button type="primary" className="w-auto font_15x btn-primary margin-t-3x border_radius_5x"><Link to="/indexx-exchange/change-password">Change Password</Link></Button>
            </div>

            <div className="row d-flex padding-2x">
                <div className="col-lg-8">
                    <TwoFactorSettings />
                </div>
            </div>
        </div>
    )
}

export default Security